import React from "react";
import { motion } from "framer-motion";
import logo1 from "../assets/valuenable.png";
import logo2 from "../assets/melooha_logo.png";
import logo3 from "../assets/unveild_logo.png";
import logo4 from "../assets/kitsa_logo.png";
import logo5 from "../assets/bidgely_logo.png";
import logo6 from "../assets/commerceiq_logo.png";
import logo7 from "../assets/felicity_logo.png";
import logo8 from "../assets/facets_logo.png";

const ClientLogoMarquee = () => {
  const logos = [logo1, logo2, logo3, logo4, logo5, logo6, logo7, logo8];
  const repeatedLogos = Array(100).fill(logos).flat();

  return (
    <div className="relative w-full overflow-hidden py-4 sm:py-6 md:py-24">
      {/* Logo Marquee */}
      <div className="relative overflow-hidden max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-10">
        {/* Gradient Overlays for fade effect - positioned inside */}
        <div className="absolute left-0 top-20 bottom-0 w-24 sm:w-32 md:w-40 z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-24 sm:w-32 md:w-40 z-10 pointer-events-none" />

        <motion.div
          className="flex space-x-14 sm:space-x-14 md:space-x-16 lg:space-x-20"
          animate={{ x: [0, -1800] }}
          transition={{
            repeat: Infinity,
            duration: 36,
            ease: "linear",
          }}
        >
          {repeatedLogos.map((logo, i) => (
            <div
              key={i}
              className="flex-shrink-0 w-32 sm:w-24 md:w-28 lg:w-32 h-16 sm:h-12 md:h-14 flex items-center justify-center group"
            >
              <img
                src={logo}
                alt="Client logo"
                className="w-full h-full object-contain opacity-65 group-hover:opacity-80 transition-opacity duration-300 brightness-0 invert"
              />
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default ClientLogoMarquee;
